import {OrderContextType} from "@/context/bussiness/types";
import {create} from "zustand";
import {devtools} from "zustand/middleware";

export const OrderStore = create<OrderContextType>()(
    devtools(
        (set, get) => ({
            isActual: false,
            handleActualOrders: () => {
                set(() => ({isActual: !get().isActual}))
            }
        })
    )
)